import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import './styles.scss';

const COOKIE_CONSENT_KEY = 'cookieConsent';

type ConsentValue = 'accepted' | 'declined';

const isConsentValue = (value: string | null): value is ConsentValue =>
  value === 'accepted' || value === 'declined';

export const CookieBanner = () => {
  const { t } = useTranslation();
  const [consent, setConsent] = useState<ConsentValue | null>(() => {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    return isConsentValue(stored) ? stored : null;
  });

  if (consent) return null;

  const handleChoice = (value: ConsentValue) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
    setConsent(value);
  };

  return (
    <div className="cookie-banner">
      <div className="cookie-banner__text">
        <Trans
          i18nKey="cookie-consent-text"
          components={{
            1: (
              // eslint-disable-next-line jsx-a11y/anchor-has-content -- content is injected by Trans
              <a
                className="cookie-banner__link"
                href="/personal-data.pdf"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      </div>
      <div className="cookie-banner__controls">
        <button
          className="button cookie-banner__button"
          onClick={() => handleChoice('accepted')}
        >
          {t('cookie-accept')}
        </button>
        <button
          className="cookie-banner__button cookie-banner__button_decline"
          onClick={() => handleChoice('declined')}
        >
          {t('cookie-decline')}
        </button>
      </div>
    </div>
  );
};
